const burger = document.getElementById("burger");
const navMenu = document.getElementById("navMenu");
const closeBtn = document.getElementById("closeBtn");
if (burger != null && navMenu != null && closeBtn != null) {
    burger.addEventListener("click", ()=>{
        navMenu.classList.add("active");
    });
    closeBtn.addEventListener("click", ()=>{
        navMenu.classList.remove("active");
    });
    document.querySelectorAll(".navigation a").forEach((link)=>{
        link.addEventListener("click", ()=>{
            navMenu.classList.remove("active");
        });
    });
}

//# sourceMappingURL=index.0fb88fe2.js.map
